module.exports = __webpack_public_path__ + "static/Maska pośmiertna Marszałka Józefa Piłsudskiego 1935 r. NAC-3f2a67163003b76aad79aaaa0c017d25.jpg";